import { render, staticRenderFns } from "./productionDefects.vue?vue&type=template&id=47e4e3f3&"
import script from "./productionDefects.vue?vue&type=script&lang=js&"
export * from "./productionDefects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports